<template>
    <div class="col-12 nopads">
        <span class="span-title"  style="font-size: 1.1em">
              {{ $t('contracts.mvr_inspections') }}
        </span>
        <div class="col-sm-12 inspectable-container" v-if="selectedInspectionTemplates.length > 0">
            <div v-for="item in selectedInspectionTemplates" :key="item.id" :class="{'d-inline' : true}">
                <span class="inspectables inspectables-selected" @click="removeFromSelection(item)">{{ item.name }}</span>
            </div>
        </div>
        <div v-else
             class="col-sm-12 mb-2">
        <span>
          {{ $t('contracts.no_inspections') }}
        </span>
        </div>
        <span v-if="inspectionTemplates.length > 0 && selectedInspectionTemplates.length !== inspectionTemplates.length" class="span-title p-2">
            {{ $t('contracts.add_inspection') }}
        </span>
        <div class="row inspectable-container py-2">
            <div
                v-for="item in inspectionTemplates"
                :key="item.id"
                class="col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables nopads"
                :class="{ 'inspectables-disabled' : isSelected(item.id) }"
                @click="addToSelection(item)">
                {{ item.name }}
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'

export default {
    name: 'ContractMvrInspectionTemplates',
    mixins: [workManagementHelper, restApi],
    props: {
        modelValue: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data: function () {
        return {
            loading: false,
            templatesLoading: false,
            defaultTemplatesLoading: false,
            inspectionTemplates: [],
            selectedInspectionTemplates: this.modelValue
        }
    },
    watch: {
        selectedInspectionTemplates: function () {
            this.$emit('update:modelValue', this.selectedInspectionTemplates)
        }
    },
    created: function () {
        this.fetchInspectionTemplates()
    },
    methods: {
        fetchInspectionTemplates: function () {
            this.inspectionTemplates = []
            this.templatesLoading = true
            this.isLoading()
            this.restFetch(this.mvrInspectionTemplateseUrl, (response) => {
                this.onInspectionLoaded()
                if (response != null) {
                    this.inspectionTemplates = response.data
                }
            }, this.onInspectionLoaded)
        },
        onInspectionLoaded: function () {
            this.templatesLoading = false
            this.isLoading()
        },
        isSelected: function (id) {
            return this.selectedInspectionTemplates.find(item => item.id === id) !== undefined
        },
        addToSelection(item) {
            let index = this.selectedInspectionTemplates.findIndex(selectedItem => selectedItem.id === item.id)
            if (index < 0) {
                this.selectedInspectionTemplates.push(item)
            }
        },
        removeFromSelection (item) {
            let index = this.selectedInspectionTemplates.findIndex(selecteditem => selecteditem.id === item.id)
            if (index >= 0) {
                this.selectedInspectionTemplates.splice(index, 1)
            }
        },
        isLoading: function () {
            this.loading = this.templatesLoading || this.defaultTemplatesLoading
        }

    }

}
</script>
